// @flow
import type { TLeague } from '../../../helpers/league';
import { getDefaultLeagueRoute, getDraftState } from '../../../helpers/league';

type TLeagueLinks = {
	arrow: string,
	settings?: string,
	invite?: ?string
}

const getLinkStates = (
	league: TLeague,
	is_commissioner: boolean,
): TLeagueLinks => {
	const league_draft_state = getDraftState(league);

	const settings_url =
		is_commissioner ? `league/${league.id}/settings` : `league/${league.id}/about`;
	const invite_url = is_commissioner ? `league/${league.id}/invite` : null;

	const states = {
		active: {},
		complete: {},
		future: {
			settings: settings_url,
			invite: invite_url,
		},
		unscheduled: {
			settings: settings_url,
			invite: invite_url,
		}
	};

	const league_draft_state_links = league_draft_state ?
		states[league_draft_state] : states.complete;
	const arrow_link = getDefaultLeagueRoute(league) || '/leagues';

	return { ...league_draft_state_links, arrow: arrow_link };
};

export default getLinkStates;


// WEBPACK FOOTER //
// ./src/pages/leagues/myLeagues/getLinkStates.js